import { CSSProperties, ReactNode } from 'react'
import Skeleton from '@mui/material/Skeleton'
import { Box } from '@mui/material'
// import { borderRadius } from '@mui/system'

interface SkeletonProps {
  variant?: 'text' | 'circular' | 'rectangular'
  width?: number | string
  height?: number | string
  radius?: string
  animation?: 'pulse' | 'wave' | false
  loading?: boolean
  className?: string
  children?: ReactNode
  style?: CSSProperties
}

export default function CustomizeSkeleton({
  variant,
  width,
  style,
  height,
  radius = '',
  animation,
  loading,
  children,
  className = '',
}: SkeletonProps) {
  return loading ? (
    <Skeleton
      style={style}
      className={className}
      sx={{ borderRadius: radius }}
      variant={variant}
      width={width}
      height={height}
      animation={animation}
    />
  ) : (
    // <Box height={height} overflow={'hidden'}>
    //   {children}
    // </Box>
    <Box>{children}</Box>
  )
}
